var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transactions-view',{attrs:{"transaction":_vm.transaction}})
}
var staticRenderFns = []

export { render, staticRenderFns }